export default __webpack_public_path__ + "static/media/the-villa6.cd077ef4.webp";